import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from '../QuizData';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';
@Component({
  selector: 'app-food-quiz',
  templateUrl: './food-quiz.component.html',
  styleUrls: ['./food-quiz.component.css']
})
export class FoodQuizComponent implements OnInit {

  foodquizForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter();
  failedMessage : string;
  activityPlanSaved : boolean;
  submitted = false;
  successMessage: string;
  activityFailed: boolean;
  quizDone: boolean;

  typicalmeals = [];

  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private cookie: CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit(): void {
    let regexPatterns = {
      weight: '0?1?[0-9]',
   };
    this.foodquizForm  =  this.formBuilder.group({
      typicalmeals: new FormArray([], minSelectedCheckboxes(1)),
      fastFood: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
      fruitsAndVeggies: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
      calorieInformation: ['', Validators.required],
      dailydrinks: ['', Validators.required],
      /*
      ownmeals: ['', Validators.required],
      weeklyalcohol: ['', Validators.required],
      weeklyprocessedmeats: ['', Validators.required],
      weeklyrefinedcarbs: ['', Validators.required],
      weeklyfriedfoods: ['', Validators.required],
      weeklydesserts: ['', Validators.required],
      */

    });

    this.typicalmeals = this.getTypicalmeals();
    this.addTypicalmealsCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });
  }

  private addTypicalmealsCheckboxes() {
    this.typicalmeals.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.foodquizForm.controls.typicalmeals as FormArray).push(control);
    });
  }

  get fmBuilder() { return this.foodquizForm.controls; }


  getFormControl(name:any) {
    return this.foodquizForm.get(name);
  }
  get formTypicalmeal() { return <FormArray>this.foodquizForm.get('typicalmeals');}
  

  getTypicalmeals(){
    return [
      { value: 1, id: 'Breakfast', name: 'Breakfast' },
      { value: 2, id: 'Lunch', name: 'Lunch' },
      { value: 3, id: 'Dinner', name: 'Dinner' },
      { value: 4, id: 'AfternoonSnack', name: 'Afternoon Snack' },
      { value: 5, id: 'EveningSnack', name: 'Evening Snack' },
      { value: 6, id: 'LateNightSnack', name: 'Late Night Snack' },
    ];
  }


  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.foodquizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.foodquizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }


  submitClick(){

    if (this.foodquizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    this.submitted = true;
    const selectedTypicalmeals = this.foodquizForm.value.typicalmeals
      .map((v, i) => v ? this.typicalmeals[i].value : null)
      .filter(v => v !== null);
    
    var foodQuizData = new QuizData();
    foodQuizData.typicalmeals= selectedTypicalmeals;
    //foodQuizData.ownmeals= String(this.foodquizForm.get(['ownmeals']).value);
    foodQuizData.fastFood= String(this.foodquizForm.get(['fastFood']).value);
    foodQuizData.fruitsAndVeggies= String(this.foodquizForm.get(['fruitsAndVeggies']).value);
    foodQuizData.calorieInformation= String(this.foodquizForm.get(['calorieInformation']).value);
    foodQuizData.dailydrinks= String(this.foodquizForm.get(['dailydrinks']).value);
    /*
    foodQuizData.weeklyalcohol= String(this.foodquizForm.get(['weeklyalcohol']).value);
    foodQuizData.weeklyprocessedmeats= String(this.foodquizForm.get(['weeklyprocessedmeats']).value);
    foodQuizData.weeklyrefinedcarbs= String(this.foodquizForm.get(['weeklyrefinedcarbs']).value);
    foodQuizData.weeklyfriedfoods= String(this.foodquizForm.get(['weeklyfriedfoods']).value);
    foodQuizData.weeklydesserts= String(this.foodquizForm.get(['weeklydesserts']).value);
    */
    
  

    this._bkoffService.setfoodquiz(foodQuizData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.cookie.set("foodDone", "true");
      this.activityPlanSaved = true;
      this.router.navigateByUrl('/quiz5');
      /*
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'Your Food Quiz has been stored';
      modalRef.componentInstance.title = 'Success';
      */
      this._bkoffService.setisFoodQuizDone();
    }).catch(()=>{
     this.failedMessage  = "Error saving Food Quiz "
     this.activityFailed = true
     this.sendUserFeedback(this.failedMessage)
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });
  }

  sendUserFeedback(message:string){
    
    const modalRef = this.modalService.open(NgbdModalContent);
    if (!this.activityPlanSaved){
      modalRef.componentInstance.name = 'Error saving data , please try again';
    }
   
  }

}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


